/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import { Button, Typography } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { toast } from "react-toastify";

import messages from "../../../../utils/messages";
import serviceFaturaSaldoChurn from "@/services/serviceFaturaSaldoChurn";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
    data: any;
    onSuccess: () => void;
}

export default function DialogRecalculate({ open, onClose, data, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const handleRequest = () => {
        setDisable(true);
        setLoading(true);

        serviceFaturaSaldoChurn
            .recalculate(data)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess, { autoClose: 2000 });
                    onClose(true);
                    onSuccess();
                }
            })
            .catch(() => {
                toast.error(messages.updateError, { autoClose: 2000 });
            })
            .finally(() => {
                setDisable(false);
                setLoading(false);
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Recalcular fatura
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography>Tem certeza que deseja recalcular esta fatura?</Typography>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <LoadingButton
                        onClick={() => handleRequest()}
                        color="primary"
                        variant="contained"
                        loading={isLoading}
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Confirmar
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}
